import React from "react";
import { Book, Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { JournalEntry } from "../../types/journal";

interface JournalHeaderProps {
    isToday: boolean;
    existingEntry: JournalEntry | null;
    isEditing: boolean;
    setIsEditing: (editing: boolean) => void;
}

export const JournalHeader: React.FC<JournalHeaderProps> = ({
    isToday,
    existingEntry,
    isEditing,
    setIsEditing
}) => {
    const { t } = useTranslation();

    return (
        <div className="p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700">
            <div className="flex justify-between items-center">
                <h2 className="text-xl sm:text-2xl font-semibold flex items-center text-gray-900 dark:text-white">
                    <Book className="w-5 h-5 sm:w-6 sm:h-6 mr-2 text-blue-600 dark:text-blue-400" />
                    {t("journal.title")}
                </h2>
                {!isToday && existingEntry && (
                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => setIsEditing(!isEditing)}
                        className="flex items-center px-3 py-1.5 rounded-lg text-sm font-medium 
              text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 
              transition-colors"
                    >
                        <Pencil className="w-4 h-4 mr-1.5" />
                        {isEditing ? t("journal.cancelEdit") : t("journal.edit")}
                    </motion.button>
                )}
            </div>
        </div>
    );
};